import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import CoachProfileChipRow from '@components/coach-tools-row/coach-profile-chip-row'

/**
 * Deduped, trimmed `skillName` labels from `coach.skills`. Same empty /
 * blank filtering as tools chips so SSR + tests stay aligned.
 */
function normalizeSkillNames(skills) {
  if (!Array.isArray(skills)) return []
  const seen = new Set()
  const out = []
  skills.forEach((raw) => {
    const t = typeof raw?.skillName === 'string' ? raw.skillName.trim() : ''
    if (t && !seen.has(t)) {
      seen.add(t)
      out.push(t)
    }
  })
  return out
}

export function coachSpecializedSkillsRowHasContent(coach) {
  return normalizeSkillNames(coach?.skills).length > 0
}

/**
 * Compact unlabeled specialized-skills chips for the flagged About
 * column. The profile places them immediately below the bio and before
 * Details — no "Specialized Skills" section heading.
 * A11y name is `aria-label="Specialized Skills"` on the region. Hash
 * destination `#coach-specialized-skills-row-heading` stays on the
 * section.
 *
 * Auto-hidden when the list is empty / only blanks. Gated by
 * `FLAG_COACH_PROFILE_UX` at the page body (not mounted on legacy).
 */
function CoachSpecializedSkillsRow({
  coach = null,
  embedded = false,
}) {
  const skillNames = useMemo(() => normalizeSkillNames(coach?.skills), [coach?.skills])

  return (
    <CoachProfileChipRow
      items={skillNames}
      ariaLabel="Specialized Skills"
      headingId="coach-specialized-skills-row-heading"
      embedded={embedded}
    />
  )
}

CoachSpecializedSkillsRow.propTypes = {
  coach: PropTypes.shape({
    skills: PropTypes.arrayOf(PropTypes.shape({
      skillName: PropTypes.string,
    })),
  }),
  /** When true, renders inside the About bio (no full-bleed band chrome). */
  embedded: PropTypes.bool,
}

export default CoachSpecializedSkillsRow
